/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/12/22, 9:09 AM
 *
 */

import { SubscriptionTab } from 'features/members/components/tabs/SubscriptionTab/SubscriptionTab';

export default SubscriptionTab;
